import '../sass/styles.scss';
import 'slick-carousel/slick/slick.js';
import 'dropkickjs/dist/dropkick.js';
import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.js';
import AOS from 'aos/dist/aos.js';


$ = jQuery;

const navigator = document.querySelector("nav");
const navbtn = document.querySelector('.nav-btn');
const close = document.querySelector(".close-menu"); 
const out = document.querySelector("main");
const navLinks = document.querySelectorAll("nav a"); // Seleccionamos todos los <a> dentro del nav


navbtn.addEventListener("click", function(){
    navigator.classList.add('show');
});

close.addEventListener("click", function(){
    navigator.classList.remove('show');
});

out.addEventListener("click", function(){
    navigator.classList.remove('show');
});

window.addEventListener("resize", function() {
    navigator.classList.remove('show');
});


const header = document.querySelector("header");

window.addEventListener('scroll', () => (window.scrollY > 200) ? header.classList.add('reduce_header') :  header.classList.remove('reduce_header')  );

navLinks.forEach(link => {
    link.addEventListener("click", function(e) {
        e.preventDefault(); // Prevenir el salto automático del anchor

        const targetId = this.getAttribute("href").slice(1); // Elimina el '#' es algo que es necesario para que funcione el offset 
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            const offset = 160; // Ajusta este valor según el alto de tu nav fijo
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });

            // Cerrar el nav
            navigator.classList.remove('show');
        }
    });
});



$(".slider").slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 8000,
    fade: true,
    adaptiveHeight: true,
    pauseOnHover: false
});


$('.slider2').slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 8000,
    fade: true,
    adaptiveHeight: true

});

$(".carousel-arrows .left2").click( () => {
    $(".slider2").slick('slickPrev');
});

$(".carousel-arrows .right2").click( () => {
    $(".slider2").slick('slickNext');
});


$('.slider3').slick({
    dots: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 8000,
    fade: true,
    asNavFor: '.contentSlide',
    adaptiveHeight: true
});

$('.contentSlide').slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 8000,
    fade: true,
    asNavFor: '.slider3',
    adaptiveHeight: true
});

// Flechas manuales
$(".carousel-arrows .left3").click(() => {
    $(".slider3").slick('slickPrev');
});
$(".carousel-arrows .right3").click(() => {
    $(".slider3").slick('slickNext');
});

// Control manual de nav
$('.slider-nav .item').on('click', function(e) {
    e.preventDefault();
    let index = $(this).index();
    $('.slider3').slick('slickGoTo', index);
});

// Sincronizar clase activa
$('.slider3').on('afterChange', function(event, slick, currentSlide) {
    $('.slider-nav .item').removeClass('active');
    $('.slider-nav .item').eq(currentSlide).addClass('active');
});

// Inicializar primero
$('.slider-nav .item').eq(0).addClass('active');



//accordeon

const showAccordeon = (elem, height) => {
    elem.parentElement.classList.add('show');
    elem.style.height = height + "px"
};
const closeAccordeon = (elem) => {
    elem.parentElement.classList.remove('show');
    elem.style.height = "0px"
};


if (document.querySelector(".accordeon")) {
    document.querySelector(".accordeon").addEventListener('click', (event) => {
        // Evitar que el código se ejecute cuando se hace clic en un <p> o <span>
        if (!event.target.matches('p, span')) {
        let show = event.target.parentElement.classList.contains("show");
        !show ? showAccordeon(event.target.nextElementSibling, event.target.nextElementSibling.scrollHeight) : closeAccordeon(event.target.nextElementSibling);
        }
    });
}
  
  //accordeon


AOS.init({
    once: true,
});


// mapa drageable 
document.addEventListener('DOMContentLoaded', function() {
    const container = document.getElementById('zoomContainer');
    const image = document.getElementById('zoomImage');
    const zoomInfo = document.getElementById('zoomInfo');
    const zoomInBtn = document.getElementById('zoomIn');
    const zoomOutBtn = document.getElementById('zoomOut');
    const resetBtn = document.getElementById('resetZoom');

    if (!container || !image) return;

    // Variables de estado
    let scale = 1;
    let translateX = 0;
    let translateY = 0;
    let isDragging = false;
    let startX = 0;
    let startY = 0;

    const minScale = 1;
    const maxScale = 5;
    const zoomStep = 0.3;

    // Función para actualizar la transformación y el estado de los botones
    function updateTransform() {
        // Aplica las transformaciones
        image.style.transform = `scale(${scale}) translate(${translateX}px, ${translateY}px)`;
        zoomInfo.textContent = `Zoom: ${Math.round(scale * 100)}%`;

        // Habilita/deshabilita los botones de control
        if (zoomOutBtn) {
            zoomOutBtn.disabled = (scale === minScale);
        }
        // El botón de reset se habilita si no estamos en la escala mínima O si estamos en la escala mínima pero la imagen está desplazada
        if (resetBtn) {
            resetBtn.disabled = (scale === minScale && translateX === 0 && translateY === 0);
        }

        // Ajusta el cursor del contenedor
        container.style.cursor = (scale > minScale) ? 'grab' : 'default';
    }

    // Función para aplicar zoom
    function zoom(factor, centerX, centerY) {
        let newScale = Math.min(Math.max(scale * factor, minScale), maxScale);

        if (newScale === scale) {
            return;
        }

        const rect = container.getBoundingClientRect();

        // Calcula el punto relativo dentro de la imagen antes de escalar
        const offsetX = (centerX - rect.left - rect.width / 2) / scale;
        const offsetY = (centerY - rect.top - rect.height / 2) / scale;

        // Ajusta la traslación para mantener el punto de zoom fijo
        translateX -= offsetX * (newScale / scale - 1);
        translateY -= offsetY * (newScale / scale - 1);

        scale = newScale;

        // Después de un zoom, es crucial re-evaluar los límites para evitar dejar espacios en blanco
        if (scale === minScale) { // Si volvemos al tamaño original
            translateX = 0;
            translateY = 0;
        } else {
            // Llama a clampTranslation para asegurar que la imagen no se salga de los límites después del zoom
            clampTranslation();
        }
        updateTransform();
    }

    // Función para resetear el zoom y la posición
    function resetZoom() {
        scale = minScale; // Vuelve a la escala mínima (100%)
        translateX = 0;
        translateY = 0;
        updateTransform();
    }

    // Nueva función para restringir la traslación dentro de los límites
    function clampTranslation() {
        // Calcula el tamaño ampliado de la imagen
        const scaledImageWidth = image.offsetWidth * scale;
        const scaledImageHeight = image.offsetHeight * scale;

        const containerWidth = container.offsetWidth;
        const containerHeight = container.offsetHeight;

        // Calcula el rango máximo de traslación permitido
        // Solo hay "overflow" si la imagen ampliada es más grande que el contenedor
        let maxTranslateX = 0;
        let maxTranslateY = 0;

        if (scaledImageWidth > containerWidth) {
            maxTranslateX = (scaledImageWidth - containerWidth) / (2 * scale);
        }
        if (scaledImageHeight > containerHeight) {
            maxTranslateY = (scaledImageHeight - containerHeight) / (2 * scale);
        }

        // Restringe translateX y translateY a estos límites
        // Asegúrate de que la traslación esté dentro de [-maxTranslateX, maxTranslateX]
        translateX = Math.max(-maxTranslateX, Math.min(maxTranslateX, translateX));
        translateY = Math.max(-maxTranslateY, Math.min(maxTranslateY, translateY));
    }


    // Event listeners para controles (SOLO BOTONES)
    zoomInBtn.addEventListener('click', () => {
        const rect = container.getBoundingClientRect();
        zoom(1 + zoomStep, rect.left + rect.width / 2, rect.top + rect.height / 2);
    });

    zoomOutBtn.addEventListener('click', () => {
        const rect = container.getBoundingClientRect();
        zoom(1 - zoomStep, rect.left + rect.width / 2, rect.top + rect.height / 2);
    });

    resetBtn.addEventListener('click', resetZoom);

    // Funciones para drag
    function startDrag(e) {
        if (scale === minScale) { // Solo permitir el arrastre si hay zoom
            return;
        }

        isDragging = true;
        const clientX = e.clientX || e.touches[0].clientX;
        const clientY = e.clientY || e.touches[0].clientY;

        // Guardamos la posición inicial del cursor RELATIVA a la traslación actual de la imagen
        // Esto es crucial para que el arrastre sea fluido y no "salte"
        startX = clientX - translateX * scale;
        startY = clientY - translateY * scale;
        
        container.style.cursor = 'grabbing';
        e.preventDefault();
    }

    function drag(e) {
        if (!isDragging) return;

        const clientX = e.clientX || e.touches[0].clientX;
        const clientY = e.clientY || e.touches[0].clientY;

        // Calculamos la nueva traslación
        // Dividimos por la escala para que el movimiento del mouse corresponda al movimiento de la imagen escalada
        translateX = (clientX - startX) / scale;
        translateY = (clientY - startY) / scale;

        // Restringe la traslación para que la imagen no se salga
        clampTranslation();
        
        updateTransform();
        e.preventDefault();
    }

    function endDrag() {
        isDragging = false;
        // El cursor debe volver a "grab" si hay zoom, o "default" si está en escala normal
        container.style.cursor = (scale > minScale) ? 'grab' : 'default';
    }

    // Event listeners para drag - Mouse
    container.addEventListener('mousedown', startDrag);
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', endDrag);

    // Event listeners para drag - Touch
    container.addEventListener('touchstart', startDrag);
    document.addEventListener('touchmove', drag);
    document.addEventListener('touchend', endDrag);

    // Prevenir selección de texto
    container.addEventListener('selectstart', (e) => e.preventDefault());

    // Inicializar al cargar
    updateTransform();
});


Fancybox.bind("[data-fancybox]", {
    // Your custom options
});